import { DomainType } from '@/enuns'

const UNEXPECTED_ERROR = 'unexpected_error'

export default ({ id, type, address, actions, status }) => ({
  id,
  type,
  address,
  status,
  isMain: type === DomainType.MAIN,
  isTemporary: type === DomainType.TEMPORARY,
  hasError: status === UNEXPECTED_ERROR,
  canBeSwitched: actions?.canBeSwitched,
  canBeMain: actions?.canBeMain,
  canBeDeleted: actions?.canBeDeleted
})
